// import React from 'react';
// import { 
//   Home, Landmark, Map, FileSearch, 
//   ShieldCheck, ArrowLeft, Layers, 
//   CheckCircle, HelpCircle, FileCheck 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function RealEstateRegistration() {
  
//   // Core real estate registration and validation services
//   const estateServices = [
//     {
//       title: "التسجيل العيني الأول والعقاري",
//       desc: "متابعة إجراءات التسجيل العيني للعقارات لدى الهيئة العامة للعقار (سجل) وتثبيت الملكيات وإصدار صكوك تسجيل الملكية الحديثة.",
//       icon: <Map className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "طلبات التملك والتعديل (إحكام)",
//       desc: "إعداد وصياغة طلبات التملك وتعديل الصكوك عبر منصة إحكام، واستكمال المرفقات القانونية والفنية ومتابعة اللجان حتى صدور الأمر الملكي.",
//       icon: <Landmark className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "الفحص النافي للجهالة للعقارات",
//       desc: "دراسة وتدقيق التاريخ القانوني للصكوك، والتحقق من سلامة المخططات وخلو العقارات من الشوائب، الرهون، أو منازعات الملكية قبل الشراء.",
//       icon: <FileSearch className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "فرز وتجزئة الوحدات العقارية",
//       desc: "الإشراف القانوني على عمليات فرز وتجزئة المجمعات السكنية والتجارية، والوحدات العقارية المشتركة بالتنسيق مع المكاتب الهندسية المعتمدة.",
//       icon: <Layers className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-slate-50 text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="خدمات التسجيل والتوثيق العقاري"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">توثيق وحماية الأصول الثابتة</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">خدمات التسجيل والتوثيق العقاري</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نواكب التحول الرقمي الشامل في القطاع العقاري السعودي لضمان تسجيل أصولك وممتلكاتك وتثبيتها بشكل قطعي لا يقبل الطعن، متوافقين مع أنظمة الهيئة العامة للعقار ووزارة العدل.
//           </p>
//         </div>
//       </section>

//       {/* Analytical Value Proposition */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col lg:flex-row gap-12 items-center">
//           <div className="flex-1">
//             <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-6 leading-tight">
//               الاستثمار الآمن يبدأ من صك ملكية سليم ومسجل عيناً
//             </h2>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-4">
//               تشهد البيئة التشريعية للعقارات في المملكة العربية السعودية إعادة هيكلة شاملة تهدف إلى رفع موثوقية الصكوك وضمان دقة البيانات الجيومكانية. إن عدم مواءمة أصولك مع التنظيمات الجديدة قد يعرض استثماراتك للعقبات الإدارية أو منازعات التداخل.
//             </p>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed">
//               يقدم مكتبنا ذراعاً قانونياً استشارياً متخصصاً يتولى مراجعة الصكوك القديمة وتحديثها، وتحويلها إلى النظام العيني الحديث، وحل المشكلات المتعلقة بالملكية، والتمثيل أمام كتابات العدل واللجان العقارية المختلفة لضمان تدفق استثماراتك دون أي عوائق.
//             </p>
//           </div>
          
//           {/* Quick Checklist Box */}
//           <div className="w-full lg:w-80 bg-slate-900 text-white p-6 rounded-xl border border-slate-800 space-y-4 shadow-lg">
//             <h3 className="font-bold text-amber-500 text-base flex items-center gap-2">
//               <ShieldCheck className="w-5 h-5" /> أهمية التسجيل الفوري:
//             </h3>
//             <ul className="space-y-3 text-xs text-slate-300">
//               <li className="flex items-center gap-2">
//                 <CheckCircle className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>اكتساب الحجية المطلقة غير القابلة للطعن.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <CheckCircle className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>سهولة إدراج العقار في بورصة العقارات والتداول المباشر.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <CheckCircle className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>تسهيل الحصول على التمويل العقاري بضمان الصك.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <CheckCircle className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>تحديد الأبعاد والمساحات بدقة تمنع تداخل الجوار.</span>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* Scope Grid */}
//       <section className="max-w-6xl mx-auto py-12 px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-3">نطاق خدماتنا العقارية</h2>
//           <p className="text-gray-500">حلول متكاملة للمطورين العقاريين، الشركات، والمستثمرين الأفراد</p>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           {estateServices.map((service, index) => (
//             <div key={index} className="bg-white p-8 rounded-xl border border-gray-100 hover:border-amber-500 hover:shadow-md transition-all duration-300">
//               <div className="p-3 bg-slate-50 rounded-lg w-fit text-slate-700 mb-4">
//                 {service.icon}
//               </div>
//               <h3 className="text-xl font-bold text-slate-800 mb-2">{service.title}</h3>
//               <p className="text-gray-500 text-sm leading-relaxed">{service.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Advisory & Litigations note */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <HelpCircle className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">الدعم القانوني في النزاعات العقارية:</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               بالإضافة إلى التسجيل الوقائي، يمتلك فريقنا خبرة واسعة في الترافع أمام المحاكم العامة والدوائر العقارية في قضايا بطلان الصكوك، تداخل الملكيات، التعويضات عن نزع الملكية للمنفعة العامة، ومنازعات عقود التطوير العقاري على الخارطة (وافي).
//             </p>
//           </div>
//         </div>
//       </section>

//     </div>
//   );
// }

import React from 'react';
import { 
  Home, Landmark, Map, FileSearch, 
  ShieldCheck, ArrowLeft, Layers, 
  CheckCircle, HelpCircle, FileCheck 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';

export default function RealEstateRegistration() {
  
  // Core real estate registration and validation services - Refactored to Navy Light
  const estateServices = [
    {
      title: "التسجيل العيني الأول والعقاري",
      desc: "متابعة إجراءات التسجيل العيني للعقارات لدى الهيئة العامة للعقار (سجل) وتثبيت الملكيات وإصدار صكوك تسجيل الملكية الحديثة.",
      icon: <Map className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "طلبات التملك والتعديل (إحكام)",
      desc: "إعداد وصياغة طلبات التملك وتعديل الصكوك عبر منصة إحكام، واستكمال المرفقات القانونية والفنية ومتابعة اللجان حتى صدور الأمر الملكي.",
      icon: <Landmark className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "الفحص النافي للجهالة للعقارات",
      desc: "دراسة وتدقيق التاريخ القانوني للصكوك، والتحقق من سلامة المخططات وخلو العقارات من الشوائب، الرهون، أو منازعات الملكية قبل الشراء.",
      icon: <FileSearch className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "فرز وتجزئة الوحدات العقارية",
      desc: "الإشراف القانوني على عمليات فرز وتجزئة المجمعات السكنية والتجارية، والوحدات العقارية المشتركة بالتنسيق مع المكاتب الهندسية المعتمدة.",
      icon: <Layers className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="خدمات التسجيل والتوثيق العقاري"
        description="نقدم حلولاً قانونية شاملة لتوثيق وحماية الأصول الثابتة وتأمين ملكياتكم العقارية"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for modern executive contrast */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">توثيق وحماية الأصول الثابتة</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">خدمات التسجيل والتوثيق العقاري</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            نواكب التحول الرقمي الشامل في القطاع العقاري السعودي لضمان تسجيل أصولك وممتلكاتك وتثبيتها بشكل قطعي لا يقبل الطعن، متوافقين مع أنظمة الهيئة العامة للعقار ووزارة العدل.
          </p>
        </div>
      </section>

      {/* Analytical Value Proposition */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-slate-200/60 flex flex-col lg:flex-row gap-12 items-center">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-extrabold text-indigo-950 mb-6 leading-tight">
              الاستثمار الآمن يبدأ من صك ملكية سليم ومسجل عيناً
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              تشهد البيئة التشريعية للعقارات في المملكة العربية السعودية إعادة هيكلة شاملة تهدف إلى رفع موثوقية الصكوك وضمان دقة البيانات الجيومكانية. إن عدم مواءمة أصولك مع التنظيمات الجديدة قد يعرض استثماراتك للعقبات الإدارية أو منازعات التداخل.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              يقدم مكتبنا ذراعاً قانونياً استشارياً متخصصاً يتولى مراجعة الصكوك القديمة وتحديثها، وتحويلها إلى النظام العيني الحديث، وحل المشكلات المتعلقة بالملكية، والتمثيل أمام كتابات العدل واللجان العقارية المختلفة لضمان تدفق استثماراتك دون أي عوائق.
            </p>
          </div>
          
          {/* Quick Checklist Box - Refactored to Executive Light Mode */}
          <div className="w-full lg:w-80 bg-slate-50 text-slate-800 p-6 rounded-xl border border-slate-200/60 space-y-4 shadow-sm">
            <h3 className="font-bold text-indigo-950 text-base flex items-center gap-2">
              <ShieldCheck className="w-5 h-5 text-blue-700" /> أهمية التسجيل الفوري:
            </h3>
            <ul className="space-y-3 text-xs text-slate-600 font-light">
              <li className="flex items-center gap-2">
                <CheckCircle className="w-4 h-4 text-indigo-950 shrink-0" />
                <span>اكتساب الحجية المطلقة غير القابلة للطعن.</span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCircle className="w-4 h-4 text-indigo-950 shrink-0" />
                <span>سهولة إدراج العقار في بورصة العقارات والتداول المباشر.</span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCircle className="w-4 h-4 text-indigo-950 shrink-0" />
                <span>تسهيل الحصول على التمويل العقاري بضمان الصك.</span>
              </li>
              <li className="flex items-center gap-2">
                <CheckCircle className="w-4 h-4 text-indigo-950 shrink-0" />
                <span>تحديد الأبعاد والمساحات بدقة تمنع تداخل الجوار.</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Scope Grid - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">نطاق خدماتنا العقارية</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">حلول متكاملة للمطورين العقاريين، الشركات، والمستثمرين الأفراد</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {estateServices.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="p-3 bg-slate-50 rounded-lg w-fit text-slate-700 mb-4">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{service.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advisory & Litigations note - Refactored Styles */}
      <section className="max-w-4xl mx-auto py-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <HelpCircle className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">الدعم القانوني في النزاعات العقارية:</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              بالإضافة إلى التسجيل الوقائي، يمتلك فريقنا خبرة واسعة في الترافع أمام المحاكم العامة والدوائر العقارية في قضايا بطلان الصكوك، تداخل الملكيات، التعويضات عن نزع الملكية للمنفعة العامة، ومنازعات عقود التطوير العقاري على الخارطة (وافي).
            </p>
          </div>
        </div>
      </section>

    </div>
  );
}